var WhiteLabelIds = /*#__PURE__*/function (WhiteLabelIds) {
  WhiteLabelIds[WhiteLabelIds["All"] = 0] = "All";
  WhiteLabelIds[WhiteLabelIds["Agoda"] = 1] = "Agoda";
  WhiteLabelIds[WhiteLabelIds["Jtb"] = 2] = "Jtb";
  WhiteLabelIds[WhiteLabelIds["JtbUat"] = 201] = "JtbUat";
  WhiteLabelIds[WhiteLabelIds["Japanican"] = 3] = "Japanican";
  WhiteLabelIds[WhiteLabelIds["JapanicanUat"] = 301] = "JapanicanUat";
  WhiteLabelIds[WhiteLabelIds["Rurubu"] = 4] = "Rurubu";
  WhiteLabelIds[WhiteLabelIds["RurubuUat"] = 401] = "RurubuUat";
  WhiteLabelIds[WhiteLabelIds["Priceline"] = 5] = "Priceline";
  WhiteLabelIds[WhiteLabelIds["ClubPremier"] = 14] = "ClubPremier";
  WhiteLabelIds[WhiteLabelIds["ClubTravel"] = 45] = "ClubTravel";
  WhiteLabelIds[WhiteLabelIds["LotteDFS"] = 47] = "LotteDFS";
  WhiteLabelIds[WhiteLabelIds["ANA"] = 50] = "ANA";
  WhiteLabelIds[WhiteLabelIds["CitiUS"] = 51] = "CitiUS";
  WhiteLabelIds[WhiteLabelIds["KrisFlyer"] = 53] = "KrisFlyer";
  WhiteLabelIds[WhiteLabelIds["CitiUSUat1"] = 5101] = "CitiUSUat1";
  WhiteLabelIds[WhiteLabelIds["CitiUSUat2"] = 5102] = "CitiUSUat2";
  WhiteLabelIds[WhiteLabelIds["CitiUSUat3"] = 5103] = "CitiUSUat3";
  WhiteLabelIds[WhiteLabelIds["CitiMexico"] = 52] = "CitiMexico";
  WhiteLabelIds[WhiteLabelIds["LifeMiles"] = 55] = "LifeMiles";
  WhiteLabelIds[WhiteLabelIds["LifeMilesUat"] = 5501] = "LifeMilesUat";
  WhiteLabelIds[WhiteLabelIds["TestStrategicPartners"] = 999] = "TestStrategicPartners";
  WhiteLabelIds[WhiteLabelIds["USBank"] = 58] = "USBank";
  WhiteLabelIds[WhiteLabelIds["Travel1MyRewardsAccess"] = 59] = "Travel1MyRewardsAccess";
  WhiteLabelIds[WhiteLabelIds["Travel2MyRewardsAccess"] = 60] = "Travel2MyRewardsAccess";
  WhiteLabelIds[WhiteLabelIds["Travel3MyRewardsAccess"] = 61] = "Travel3MyRewardsAccess";
  WhiteLabelIds[WhiteLabelIds["Travel4MyRewardsAccess"] = 62] = "Travel4MyRewardsAccess";
  WhiteLabelIds[WhiteLabelIds["WestJet"] = 63] = "WestJet";
  WhiteLabelIds[WhiteLabelIds["USBankUat1"] = 5801] = "USBankUat1";
  WhiteLabelIds[WhiteLabelIds["Travel1MyRewardsAccessUat1"] = 5901] = "Travel1MyRewardsAccessUat1";
  WhiteLabelIds[WhiteLabelIds["Travel2MyRewardsAccessUat1"] = 6001] = "Travel2MyRewardsAccessUat1";
  WhiteLabelIds[WhiteLabelIds["Travel3MyRewardsAccessUat1"] = 6101] = "Travel3MyRewardsAccessUat1";
  WhiteLabelIds[WhiteLabelIds["Travel4MyRewardsAccessUat1"] = 6201] = "Travel4MyRewardsAccessUat1";
  WhiteLabelIds[WhiteLabelIds["WestJetUat1"] = 6301] = "WestJetUat1";
  WhiteLabelIds[WhiteLabelIds["Rocketmiles"] = 10] = "Rocketmiles";
  WhiteLabelIds[WhiteLabelIds["RocketmilesUat"] = 1001] = "RocketmilesUat";
  return WhiteLabelIds;
}({});

export { WhiteLabelIds };
//# sourceMappingURL=themeProviderInterface.js.map
